import React from 'react'
import tankImage from "../../../images/products/B.jpg"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/home/p-3.jpg'

function WovenBag() {

  const values = [
  {
    number: 1,
    text: "High strength – Made with strong woven fabric to handle heavy loads without tearing.",
  },
  {
    number: 2,
    text: "Moisture resistant – Laminated options provide protection against moisture and dust.",
  },
  {
    number: 3,
    text: "Reusable – Durable design allows for multiple uses, reducing packaging costs.",
  },
  {
    number: 4,
    text: "Lightweight – Easy to carry and transport while reducing shipping weight.",
  },
  {
    number: 5,
    text: "Custom sizes and prints – Tailored to your branding and packaging requirements.",
  },
  {
    number: 6,
    text: "UV stabilized – Ideal for outdoor storage without material degradation.",
  },
  {
    number: 7,
    text: "Eco-friendly – Made from recyclable polypropylene for sustainable use.",
  },
  {
    number: 8,
    text: "Multi-industry use – Suitable for grains, fertilizers, cement, sugar, and more.",
  },
];


  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'PP Woven Bag'} pagesub={'Products'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
       <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">Reliable Bags. Smarter Packaging.</h2>
  <p style={{ textAlign: "justify" }}>
    PP (Polypropylene) woven bags are a preferred choice for packing and transporting goods in agriculture, construction, and industrial sectors. They offer the strength and flexibility needed to handle bulk materials efficiently and cost-effectively.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we produce high-quality PP woven bags using 100% virgin polypropylene. These bags are tear-resistant, lightweight, and moisture-proof, with optional lamination for extra protection. They can also be printed with your brand or product details for easy identification and promotion.
  </p>
  <p style={{ textAlign: "justify" }}>
    Available in various sizes, colors, and GSM options, our PP woven bags are suitable for packaging grains, fertilizers, cement, sugar, sand, and more. Durable, reusable, and economical—they're a smart solution for dependable storage and transport.
  </p>
</div>

      </div>
    </section>
 {/* <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">PP Woven Bag</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
               PP Woven Bag available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
                PP Fabric Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>1850</td>
              <td>2070</td>
              <td>2650</td>
              <td>3050</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>1550</td>
              <td>1870</td>
              <td>1940</td>
              <td>2120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default WovenBag